import { DecodeHex } from '../HexDecoder/HexDecoder';
import { SplitQueryString } from '../QueryString/QueryString';

export function GetSearchMessage(hexString) {
  if (!hexString) { return { noResultsFound: undefined, showingResultsFor: undefined }; }

  const decodedString = DecodeHex(hexString);
  if (!decodedString) { return { noResultsFound: undefined, showingResultsFor: undefined }; }

  const searchMessageParams = SplitQueryString(decodedString);

  return {
    noResultsFound: searchMessageParams['sta'],
    showingResultsFor: searchMessageParams['sa'],
  };
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/SearchMessage/SearchMessage.js